module.exports = __webpack_public_path__ + "static/media/7.955c6fc2.png";